const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: '最小值和最大值输入无效。',
    invalid_options: '字段选项无效。',
    invalid_regex_format: '正则表达式格式无效。',
    invalid_address_parts: '地址部分无效。',
    invalid_fullname_parts: '全名部分无效。',
    name_exists: '已存在具有该名称的字段。',
    conflicted_sie_order: '登录体验的字段顺序值冲突。',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
